import React, { useEffect, useState } from 'react';
import client from '../../api';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import calculatePercentage from '../../utils/calculatePercentage';
import Percentage from '../../components/Percentage';

const DetailInvoice = ({ params }) => {
  const { user } = useSelector(state => state.auth);
  const [detailInvoice, setDetailInvoice] = useState([]);

  const Total = [
    {
      name: 'Belum Bayar',
      total: detailInvoice?.unpaid ?? 0,
      className: 'cancel'
    },
    {
      name: 'Partial',
      total: detailInvoice?.partial,
      className: 'waiting'
    },
    {
      name: 'Overdue',
      total: detailInvoice?.overdue,
      className: 'overdue'
    },
    {
      name: 'Lunas',
      total: detailInvoice?.paid,
      className: 'completed'
    }
  ];

  const getData = async () => {
    const response = await client.get(
      `/api/customers/dashboard/detail-invoice`,
      {
        params,
        headers: {
          'Content-type': 'application/json',
          Authorization: `Bearer ${user.data.token}`
        }
      }
    );
    return response.data;
  };

  useEffect(() => {
    getData(params)
      .then(value => {
        setDetailInvoice(value);
      })
      .catch(() => toast.error('Internal Server Error'));
  }, [params]);

  return (
    <div className='dashboard-panel'>
      <div className='dashboard-panel__head'>
        <h3 className='dashboard-panel__title'>Detail Invoice</h3>
        <p className='dashboard-panel__subtitle'>
          Status pembayaran pada periode terpilih
        </p>
      </div>

      <div className='dashboard-kpi'>
        <div className='dashboard-kpi__item'>
          <p className='dashboard-kpi__label'>Total invoice</p>
          <p className='dashboard-kpi__value'>
            {detailInvoice?.total_invoices ?? 0}
          </p>
        </div>
        <div className='dashboard-kpi__item'>
          <p className='dashboard-kpi__label'>Outstanding</p>
          <p className='dashboard-kpi__value dashboard-kpi__value--sm'>
            {detailInvoice?.total_outstanding ?? '-'}
          </p>
        </div>
      </div>

      <div className='dashboard-status'>
        {Total.map((row, index) => {
          const pct =
            calculatePercentage(row?.total, detailInvoice?.total_invoices) ||
            0;
          return (
            <div className='dashboard-status__row' key={index}>
              <span className={`dashboard-status__dot ${row.className}`} />
              <p className='dashboard-status__name'>{row.name}</p>
              <p className='dashboard-status__count'>{row.total ?? 0}</p>
              <Percentage value={pct} />
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default DetailInvoice;
